(function(){
  // Toast
  var toast=document.getElementById('toast'),tm=document.getElementById('toast-msg'),tt;
  function showToast(m){if(!toast)return;tm.textContent=m;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show')},2400)}

  function refreshCount(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=c.item_count});
    });
  }

  // Ajout au panier AJAX (boutons .card-add avec data-variant)
  document.addEventListener('click',function(e){
    var add=e.target.closest('.card-add');
    if(add){
      e.preventDefault();e.stopPropagation();
      var id=add.getAttribute('data-variant');
      if(!id)return;
      add.style.opacity=.6;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(function(r){return r.json()}).then(function(){
          add.style.opacity=1;refreshCount();
          showToast('« '+add.getAttribute('data-name')+' » ajouté au panier');
        }).catch(function(){add.style.opacity=1});
      return;
    }
    // Clic sur une carte produit -> redirection directe vers la fiche (pas de quickview)
  });

  // Modal quick view
  var ov=document.getElementById('modalOv');
  function openModal(d){
    if(!ov)return;
    ov.querySelector('#modalImg').src=d.img||'';
    ov.querySelector('#modalCat').textContent=d.cat||'';
    ov.querySelector('#modalName').textContent=d.name||'';
    ov.querySelector('#modalPrice').textContent=d.price||'';
    ov.querySelector('#modalDesc').textContent=d.desc||'';
    var link=ov.querySelector('#modalLink');if(link)link.href=d.url||'#';
    var addb=ov.querySelector('#modalAdd');if(addb){addb.setAttribute('data-variant',d.variant||'');addb.setAttribute('data-name',d.name||'')}
    ov.classList.add('open');
  }
  function closeModal(){if(ov)ov.classList.remove('open')}
  if(ov){
    ov.addEventListener('click',function(e){if(e.target===ov)closeModal()});
    var c=ov.querySelector('#modalClose');if(c)c.onclick=closeModal;
  }
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal()});

  // Reveal au scroll — robuste : le contenu reste TOUJOURS visible
  var reveals=[].slice.call(document.querySelectorAll('.reveal'));
  function showAll(){reveals.forEach(function(el){el.classList.add('in')})}
  if('IntersectionObserver' in window && reveals.length){
    reveals.forEach(function(el){el.classList.add('pre')});
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})},{threshold:0,rootMargin:'0px 0px -6% 0px'});
    reveals.forEach(function(el){io.observe(el)});
    // filet de sécurité : tout révéler après 1,4s, rien ne reste masqué
    setTimeout(showAll,1400);
  } else {
    showAll();
  }

  // Recherche overlay
  var sOv=document.getElementById('searchOv'),sBtn=document.getElementById('searchBtn'),sClose=document.getElementById('searchClose'),sInput=document.getElementById('searchInput');
  function openSearch(){if(sOv){sOv.classList.add('open');sOv.setAttribute('aria-hidden','false');if(sInput)setTimeout(function(){sInput.focus()},120);}}
  function closeSearch(){if(sOv){sOv.classList.remove('open');sOv.setAttribute('aria-hidden','true');}}
  if(sBtn)sBtn.addEventListener('click',openSearch);
  if(sClose)sClose.addEventListener('click',closeSearch);

  // Menu mobile (drawer)
  var dr=document.getElementById('mdrawer'),bg=document.getElementById('burger'),drC=document.getElementById('mdrawerClose');
  function openDrawer(){if(dr){dr.classList.add('open');dr.setAttribute('aria-hidden','false');}}
  function closeDrawer(){if(dr){dr.classList.remove('open');dr.setAttribute('aria-hidden','true');}}
  if(bg)bg.addEventListener('click',openDrawer);
  if(drC)drC.addEventListener('click',closeDrawer);
  if(dr)dr.addEventListener('click',function(e){if(e.target===dr)closeDrawer();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeSearch();closeDrawer();}});

  refreshCount();
})();
